import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthState, authKey } from './auth.state';
import { AuthStep } from '@app/core/authentication/enums/auth-step.enum';
import { IAuthStepData } from '@app/core/authentication/interfaces/auth-step-data';
import { IAuthErrorResponse } from '@app/api/interfaces/auth.interface';

export const selectAuthState = createFeatureSelector<IAuthState>(authKey);

export const selectIsAuthInitialized = createSelector(
  selectAuthState,
  (authState: IAuthState): boolean => authState.initialized
);

export const selectIsAuthLoading = createSelector(
  selectAuthState,
  (authState: IAuthState): boolean => authState.loading
);

export const selectAuthStep = createSelector(
  selectAuthState,
  (authState: IAuthState): AuthStep => authState?.step || AuthStep.Login
);

export const selectAuthStepData = createSelector(
  selectAuthState,
  (authState: IAuthState): IAuthStepData => authState.stepData
);

export const selectAuthError = createSelector(
  selectAuthState,
  (authState: IAuthState): IAuthErrorResponse | null => authState.error
);
